import React from 'react'

import { Element, Text } from "components/shared/base"
import ImageAndTextItem from "./ImageAndTextItem"
import {
  PrismicHomepageDataBodyImageAndTextPrimary,
  PrismicHomepageDataBodyImageAndTextItem
} from "types/__generated__/gatsby-graphql"

interface OwnProps {
  items: PrismicHomepageDataBodyImageAndTextItem[]
}

export type ImageAndTextSectionProps = OwnProps & PrismicHomepageDataBodyImageAndTextPrimary 

const ImageAndTextSection: React.FC<ImageAndTextSectionProps> = ({
  background_color,
  font_color,
  full_bleed_images,
  headline,
  items
}): React.ReactElement => {

  const headlineText = headline?.text || "";

  return (
    <Element
      as="section"
      bg={background_color}
      color={font_color}
      my={["50px 0", "70px"]}
      mx={full_bleed_images ? '0': "20px"}
      pb={[`70px`, `${full_bleed_images ? "70px": "0"}`, "0"]}
    >
      <Element m="0 auto" maxWidth={full_bleed_images ? "1440px" : "1140px"}>
        {headlineText && (
          <Text as="h2" textAlign="center">{headlineText}</Text>
        )}
        <Element
          display="grid"
          gridColumnGap="20px"
          gridTemplateColumns="repeat(12, 1fr)"
        >
          {items?.map((item, index) => (
            <ImageAndTextItem
              key={index}
              gridColumnEnd={["span 12", `${full_bleed_images ? "span 12": "span 6"}`, "span 6"]}
              item={item}
              justifyContent={full_bleed_images ? "center" : "auto"}
              textAlign={full_bleed_images ? "center" : "left"}
            />
          ))}
        </Element>
      </Element>
    </Element>
  )
}

export default ImageAndTextSection
